import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import RTEEditorModal from '../../misc/RTEEditorModal';
import Button from '../../misc/Button';

const StyledWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: ${(props) => props.padding};
  background-color: ${(props) => props.backgroundColor};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius}px;

  .rte-field-wrapper-class {
    pointer-events: none;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: ${(props) => props.borderRadius}px;
  }

  .rte-field-editor-class {
    height: 100%;
    width: 100%;
    border: 1px solid transparent;
    border-radius: ${(props) => props.borderRadius}px;
  }

  .rdw-editor-wrapper {
    .rdw-editor-main {
      overflow: hidden;
      line-height: 1.2;
      .public-DraftStyleDefault-block {
        margin: 0px;
      }
    }
  }

  button {
    visibility: hidden;
  }

  :hover {
    button {
      visibility: visible;
    }
  }

`;

const StyledButtonWrapper = styled.div`
  position: absolute;
  bottom: 6px;
  right: 6px;
`;

class RTEEditor extends PureComponent {

  static propTypes = {

    fieldId: PropTypes.string,
    fieldIdentifier: PropTypes.string,
    fieldPositionId: PropTypes.string,

    value: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
    ]),
    placeholder: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,

    //Styles
    borderWidth: PropTypes.number,
    borderRadius: PropTypes.number,
    borderColor: PropTypes.string,
    padding: PropTypes.number,
    backgroundColor: PropTypes.string

  }

  static defaultProps = {
    disabled: false
  }

  constructor(props) {
    super(props);

    const { value } = props;

    let contentState = value;
    if (value && typeof value !== 'object') contentState = JSON.parse(value);

    this.state = { contentState, displayModal: false };

  }

  render() {

    const { displayModal, contentState } = this.state;

    const {
      fieldPositionId,
      placeholder,
      disabled,
      borderWidth,
      borderRadius,
      borderColor,
      padding,
      backgroundColor,
    } = this.props;

    /**
     * We join width and color to a single border style because chrome displays
     * the border as a two tone color if you use border-color and border-width
     * indvidually.
     */
    const border = `${borderWidth}px solid ${borderColor}`;

    return (
      <StyledWrapper
        data-testid={`${fieldPositionId}-rte-field-wrapper`}
        {...{
          border,
          borderRadius,
          padding,
          backgroundColor
        }}
      >
        <Editor
          disabled
          contentState={contentState}
          placeholder={placeholder}
          toolbarHidden
          toolbarClassName="rte-field-toolbar-class"
          wrapperClassName="rte-field-wrapper-class"
          editorClassName="rte-field-editor-class"
          testid={`${fieldPositionId}-rte-field`}
          tabIndex={-1}
        />
        <RTEEditorModal
          id={fieldPositionId}
          display={displayModal}
          value={contentState}
          onHide={() => this.setState({ displayModal: false })}
          onSubmit={this.handleSubmit}
        />
        {disabled ? null : (
          <StyledButtonWrapper>
            <Button
              size="sm"
              text="Edit"
              onClick={() => this.setState({ displayModal: true })}
            />
          </StyledButtonWrapper>
        )}
      </StyledWrapper>
    );
  }

  handleSubmit = (contentState) => {

    const { fieldId, fieldIdentifier, fieldPositionId, onChange } = this.props;
    this.setState({ contentState, displayModal: false });

    if (onChange) onChange(fieldId, fieldIdentifier, fieldPositionId, JSON.stringify(contentState));

  }

}

export default RTEEditor;
